import { FC, useState } from 'react'
import { StyleTableCard, StyleTable } from './style'
import { TableProps } from './interface'
import TableHead from './head'
import TableBody from './body'
import TableFilter from './filter'
const Table: FC<TableProps> = ({ columns, data, filter }) => {
  const [search, setSearch] = useState<string>('')
  const filterProps =
    filter?.hasSearch && !!filter?.searchFrom && !filter?.isServerSide
      ? {
          onSearch: (event: any) => {
            setSearch(event.target.value)
          },
        }
      : {}
  return (
    <StyleTableCard>
      {!!filter && <TableFilter {...filter} {...filterProps} />}
      <StyleTable>
        <TableHead columns={columns} />
        <TableBody
          columns={columns}
          data={
            !!search
              ? data?.filter((item: any) =>
                  item[filter?.searchFrom]
                    ?.toLowerCase?.()
                    .includes(search?.toLowerCase?.() || ''),
                )
              : data
          }
        />
      </StyleTable>
    </StyleTableCard>
  )
}

export default Table
